import clientProfile from '@/locales/es/clientProfile/clientProfile.locales';

export default {
    ...clientProfile,
};
